import React, { useEffect } from "react";
import { PhoneNumberForm } from "./phone-number-form";
import { useAppDispatch, useAppSelector } from "../../../../store";
import { VerifyOtpForm } from "./verify-otp";
import { setLoginState } from "features/login/slice";

export const Otp = () => {
  const dispatch = useAppDispatch();
  const loginState = useAppSelector((state) => state.login.loginState);
  useEffect(() => {
    dispatch(setLoginState("phone-number"));
  }, [dispatch]);
  return (
    <div className="d-flex flex-grow-1 h-100 w-100">
      {loginState === "phone-number" ? <PhoneNumberForm /> : <VerifyOtpForm />}
    </div>
  );
};
